import React from 'react';

export const BackButtonIcon = () => {
    return (
        <img
            src="/img/back-btn.png"
            alt="Back Button"
            width="13"
            height="20"
            data-testid="back-button-icon"
        />
    );
};

export default BackButtonIcon;
